import {
  BankOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { dirhams, isNegative, present } from '@horof/shared';
import { Button, Skeleton } from 'antd';
import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router';
import { useQuery } from 'urql';
import {
  OperationsDocument,
  useCanWrite,
  useFinanceLists,
  withBalances,
} from './finance-data';
import { OperationRow } from './OperationsPage';

/**
 * The treasurer's home: what is in each account, three big buttons, and the
 * last entries (to see that what he just saved is there).
 */
export function HomePage() {
  const canWrite = useCanWrite();
  const navigate = useNavigate();
  const [{ data: lists }] = useFinanceLists();
  const [{ data }] = useQuery({
    query: OperationsDocument,
    variables: { filter: null, orderBy: ['CREATED_AT_DESC'], first: 5 },
    context: useMemo(() => withBalances, []),
    requestPolicy: 'cache-and-network',
  });
  const accounts = present(lists?.financialAccounts?.nodes);
  const recent = present(data?.financialOperations?.nodes);

  return (
    <div className="page">
      {!lists ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <div className="balances">
          {accounts.map((a) => (
            <div key={a.id} className="card balance-card">
              <span className="field-hint">{a.name}</span>
              <strong
                className={`balance-amount${isNegative(a.currentBalance) ? ' is-negative' : ''}`}
              >
                {dirhams(a.currentBalance)}
              </strong>
            </div>
          ))}
        </div>
      )}

      {canWrite && (
        <div className="home-actions">
          <Button
            className="home-button is-credit"
            icon={<PlusCircleOutlined />}
            onClick={() => navigate('/new/credit')}
          >
            مدخول
          </Button>
          <Button
            className="home-button is-debit"
            icon={<MinusCircleOutlined />}
            onClick={() => navigate('/new/debit')}
          >
            مصروف
          </Button>
          <Button
            className="home-button is-bank"
            icon={<BankOutlined />}
            onClick={() => navigate('/bank')}
          >
            إيداع أو سحب من البنك
          </Button>
        </div>
      )}

      <h2 className="section-title">آخر ما سُجِّل</h2>
      {!data && <Skeleton active paragraph={{ rows: 3 }} />}
      {data && recent.length === 0 && (
        <div className="field-hint">لا عمليات بعد.</div>
      )}
      <ul className="operation-list">
        {recent.map((op) => (
          <li key={op.id}>
            <OperationRow op={op} />
          </li>
        ))}
      </ul>
      <Link to="/operations">
        <Button size="large" block>
          كل العمليات
        </Button>
      </Link>
    </div>
  );
}
